import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { QuarterlySecurityReportData } from "../types";

export const useQuarterlySecurityReportData = () => {
	const data = useSelector<StoreType, QuarterlySecurityReportData[] | undefined>(
		s => s.data.reports.securityCommission.quarterlylSecurity.data
	);

	const dispatch = useDispatch();
	const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [dispatch]);

	return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
